<template>
  <div>
    <div class="baic_content">
      <h3>基础信息</h3>
      <div>
        <div class="bacle_input">
          <h5>考试名称:</h5>
          <el-input
            type="text"
            placeholder="请输入考试名称"
            v-model.trim="$parent.newExamInfo.ExamName"
            maxlength="30"
            show-word-limit
            resize="none"
            class="check_textarea"
          >
          </el-input>
        </div>
        <div class="bacle_input">
          <h5>组卷模式:</h5>
          <div>
            <el-input
              v-model="$parent.newExamInfo.PaperModeExam"
              placeholder="请选择组卷模式"
              class="check_input"
              readonly></el-input>
          </div>
          <el-button type="primary" disabled style="background-color: #a0cfff;border-color: #a0cfff;">请选择</el-button>
        </div>
        <div class="bacle_input">
          <h5>命题方式:</h5>
          <div>
            <el-input
              v-model="$parent.newExamInfo.PaperModeName"
              placeholder="请选择命题方式"
              class="check_input"
              style="outline: none"
              readonly></el-input>
          </div>
          <el-button type="primary" disabled style="background-color: #a0cfff;border-color: #a0cfff;">请选择</el-button>
        </div>
      </div>

      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="backfor">返回</el-button>
        <el-button type="success" class="submit_btn" @click="handleNext">下一步</el-button>
      </div>
    </div>
    <!-- 弹框 -->
    <sys-dialog
      :title="messageDialog.title"
      :width="messageDialog.width"
      :height="messageDialog.height"
      :visible="messageDialog.visible"
      @onConfirm="messageConfirm"
      @onClose="messageClose">
      <div slot="content" class="message-text">
        <i class="iconfont icon-tishi1"></i><p style="">试卷名称【{{$parent.newExamInfo.ExamName}}】重复，请重新填写！</p>
      </div>
    </sys-dialog>
  </div>
</template>

<script>
import SysDialog from "@/components/system/SysDialog";
import loginvuex from "@/store/index";
import { examIsExists } from "@/api/index.js";
export default {
  name: "Pageone",
  props: ["nextPage"],
  components: {
    SysDialog
  },
  data() {
    return {
      messageDialog:{
        title:"温馨提示",
        width:400,
        height:62,
        visible:false
      },
    };
  },
  activated() {
    console.log(this.$parent.newExamInfo,'this.$parent.newExamInfo');
    
  },
  methods: {
    messageConfirm:function(){
      this.messageDialog.visible = false;
    },
    messageClose:function(){
      this.messageDialog.visible = false;
    },
    backfor() {
      this.$parent.back();
    },
    // 试卷重复拦截
    async handleNext() {
      let parms = {
        examName: this.$parent.newExamInfo.ExamName, // 考试名称
        examType: "online",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        examID: "",
      };
      if(!this.$parent.newExamInfo.ExamName){
        this.$message.warning("考试名称不能为空！");
        return;
      }
      //判断试卷是否存在
      const Data = await examIsExists(parms);
      if (Data.status === 200) {
        if (Data.data.Data.count == 0) {
          this.nextPage(1)
        } else {
          this.messageDialog.visible = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.baic_content {
  background-color: white;
  min-width: 1527px;
  padding-bottom: 80px;
  border-radius: 4px 4px 4px 4px;
  h3 {
    display: inline-block;
    width: 100%;
    height: 60px;
    background: #cce7ff;
    border-radius: 4px 4px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    padding-top: 17px;
    padding-left: 24px;
  }
  .bacle_input {
    display: flex;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 240px 0 0px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-input__inner {
  border: 1px solid #dcdfe6;
}
.message-text{
  display: flex;
  i {
    font-size: 16px;
    color: #ffc664;
    margin-right: 10px;
    transform: translateY(4px);
  }
  p {
    text-align: left;
    font-size: 15px;
    font-weight: 400;
    line-height: 26px;
    color: #333333;
    opacity: 1;
  }
}
</style>
